import { api } from "../api";

/**
 * findAllCitiesByStateIdListResponse - Function that finds on database all cities by state id as select list   
 * /cities/{stateId}  
 * method GET 
 * @async-function
 */
const findAllCitiesByStateIdListResponse = async (token: string, stateId: number) => {
    const response = await api.get(
        `/cities/${stateId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};
export default findAllCitiesByStateIdListResponse;